import { render } from "./TotalComponent.vue?vue&type=template&id=32b4c7ec&scoped=true"
import script from "./TotalComponent.vue?vue&type=script&lang=js"
export * from "./TotalComponent.vue?vue&type=script&lang=js"

import "./TotalComponent.vue?vue&type=style&index=0&id=32b4c7ec&scoped=true&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b4c7ec"]])

export default __exports__